import { render, staticRenderFns } from "./DefaultAbout.vue?vue&type=template&id=7285f1c8&scoped=true&"
import script from "./DefaultAbout.vue?vue&type=script&lang=js&"
export * from "./DefaultAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7285f1c8",
  null
  
)

export default component.exports